import { ReactElement } from 'react';

export const Packages = (): ReactElement => {
  return <>Packages</>;
};
